
import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

interface OGMetaTagsProps {
  title?: string;
  description?: string;
  path?: string;
}

const OGMetaTags: React.FC<OGMetaTagsProps> = ({
  title,
  description,
  path
}) => {
  const location = useLocation();
  
  // Get the current path or use the provided path
  const currentPath = path || location.pathname;
  
  // Generate default title based on the path
  const generateDefaultTitle = () => {
    if (currentPath === '/') return 'VirtuStaff.ai - AI-Powered Virtual Staff Platform';
    
    // Convert path to title (e.g., /pricing -> Pricing - VirtuStaff.ai)
    const pathSegment = currentPath.split('/').pop() || '';
    if (!pathSegment) return 'VirtuStaff.ai';
    
    const formattedTitle = pathSegment
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
    
    return `${formattedTitle} - VirtuStaff.ai`;
  };
  
  // Use provided title or generate default
  const pageTitle = title || generateDefaultTitle();
  
  // Use provided description or default
  const pageDescription = description || 'Hire AI staff to automate your business functions';
  
  // Generate the canonical URL
  const baseUrl = window.location.origin;
  const canonicalUrl = `${baseUrl}${currentPath}`;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content="/logo-svg.svg" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <link rel="canonical" href={canonicalUrl} />
      <link rel="icon" href="/logo-svg.svg" type="image/svg+xml" />
    </Helmet>
  );
};

export default OGMetaTags;
